export default "__VITE_ASSET__0c0UoP$7__"